<!--
 * @Descripttion: 数据导入弹窗
 * @Author: zenghua.wang
 * @Date: 2021-09-07 16:22:27
 * @LastEditors: zenghua.wang
 * @LastEditTime: 2021-09-08 14:46:26
-->
<template>
  <el-dialog
    v-if="visible"
    :title="title"
    :visible.sync="visible"
    width="30%"
    append-to-body
    @close="onCancel"
  >
    <el-form
      inline
      ref="form"
      :model="form"
      :size="option.size"
      @submit.native.prevent
      label-width="120px"
      label-suffix="："
    >
      <el-form-item
        label="导入文件"
        required
      >
        <div class="file-panel">
          <input
            type="file"
            class="file-panel-input"
            ref="fileInput"
            accept=".xls,.xlsx"
            @change="selectFile($event)"
          >
          <el-button
            class="file-panel-button"
            type="success"
            icon="el-icon-upload"
          >
            选择文件
          </el-button>
        </div>
        <div
          class="xa-form-tips"
          style="height:20px;"
        >备注：只能上传xls/xlsx文件</div>
        <span v-text="form.label"></span>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button
        size="small"
        type="primary"
        @click="onSubmit"
      >确 定</el-button>
      <el-button
        size="small"
        @click="onCancel"
      >取 消</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { deepClone } from '@/dragComponents/utils'

export default {
  name: 'report-import',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    option: {
      type: Object,
      default: () => {}
    },
    data: {
      type: Object,
      default: () => {}
    },
    change: {
      type: Function
    }
  },
  data() {
    return {
      visible: false,
      form: {
        label: ''
      }
    }
  },
  watch: {
    show(val) {
      this.visible = val
    },
    visible: {
      handler(val) {
        this.$emit('update:show', val)
      },
      deep: true
    }
  },
  methods: {
    selectFile(evt) {
      this.form.file = evt.target.files[0]
      this.form.label = this.form.file.name
    },
    onSubmit() {
      if (!this.form.file) {
        return this.$message.error('请选择文件')
      }
      let form = deepClone(this.form)
      this.$emit('change', form, this.option, this.data)
      this.onCancel()
    },
    onCancel() {
      this.form.label = ''
      this.form.file = null
      this.$refs.fileInput.value = null
      this.visible = false
    }
  }
}
</script>
<style lang="scss" scoped>
.file {
  &-panel {
    position: relative;
    overflow: hidden;
    width: 120px;
    height: 40px;
    cursor: pointer;

    &-button {
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      top: 0;
      width: 120px;
      height: 40px;
    }

    &-input {
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      opacity: 0;
      filter: Alpha(opacity=0);
      z-index: 4;
      cursor: pointer;
    }
  }
}
</style>

